import React, { useState } from "react";
import { scanPackage } from "../api/packageService";

export default function PackageScanPage() {
    const [trackingNumber, setTrackingNumber] = useState("");
    const [packageData, setPackageData] = useState(null);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!trackingNumber.trim()) {
            setError("Tracking number is required.");
            return;
        }

        try {
            setLoading(true);
            setError("");
            setPackageData(null);

            const data = await scanPackage(trackingNumber.trim());
            setPackageData(data);
            setTrackingNumber("");
        } catch (err) {
            setError(
                err?.response?.data?.message ||
                err?.message ||
                "Package scan failed."
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-xl mx-auto p-6 bg-white rounded shadow">
            <h1 className="text-xl font-bold mb-4">Package Scan</h1>

            <form onSubmit={handleSubmit} className="flex gap-2 mb-4">
                <input
                    value={trackingNumber}
                    onChange={(e) => setTrackingNumber(e.target.value)}
                    placeholder="Tracking number"
                    className="border p-2 rounded flex-1"
                />

                <button
                    type="submit"
                    disabled={loading}
                    className="bg-indigo-600 text-white px-4 py-2 rounded"
                >
                    {loading ? "Scanning..." : "Scan"}
                </button>
            </form>

            {error && <p className="text-red-600">{error}</p>}

            {packageData && (
                <div className="border rounded p-4 mt-4">
                    <p><b>ID:</b> {packageData.id ?? "�"}</p>
                    <p><b>Tracking:</b> {packageData.trackingNumber ?? "�"}</p>
                    <p><b>Status:</b> {packageData.status ?? "�"}</p>
                </div>
            )}
        </div>
    );
}